import axios from 'axios';
import * as React from 'react';
import { requestCalendarEventsByRange } from '../asyncHelpers/calendarEventsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { GenericReducer, genericReducer } from '../sic-lib/reducers/genericReducer';
import { CalendarEvent, RetrieveCalendarEventsByRange } from '../sic-lib/types/CalendarEvent';
import { mapStartEndDateToJsDate } from '../sic-lib/utils/functionalMappers';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

interface HookState {
    requestStatus: RequestStatus;
    getContactCalendarEventsResult: CalendarEvent[];
}

export default function useAsyncGetScheduleCalendarEvents() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [hookState, hookDispatch] = React.useReducer<GenericReducer<HookState>>(genericReducer, {
        requestStatus: RequestStatus.none,
        getContactCalendarEventsResult: [],
    });

    const asyncGetCalendarEventsByRange = async (
        startDate: Date,
        endDate: Date,
        userName: string | null,
    ) => {
        try {
            hookDispatch({ requestStatus: RequestStatus.active });

            const payload = {
                start: startDate,
                end: endDate,
                userName: userName,
            } as RetrieveCalendarEventsByRange;

            const { data } = await requestCalendarEventsByRange(payload, request_token.token);

            console.log('data');

            hookDispatch({
                getContactCalendarEventsResult: data.map(mapStartEndDateToJsDate),
                requestStatus: RequestStatus.success,
            });
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                /* Notify user of failed http request */
                const toastData = createErrorToast('Error while retrieving calendar events');

                dispatch(createToast({ toastData }));

                /* Update state */
                hookDispatch({ requestStatus: RequestStatus.error });
            }
        }
    };

    return {
        ...hookState,
        ...{
            asyncGetCalendarEventsByRange,
        },
    };
}
